import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
import _ from "lodash";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
import { ref} from "vue";
import { DateTime } from 'luxon';
export const useDukListModel = defineStore(
    'dukListModel',
    () => {


         const filter = ref(null);
         const sort = ref(null);
                const take = ref(null);

                const setFilter = (e) => {
                    filter.value = e;
                }

                const setSort = (e) => {
                    sort.value = e;
                }
        
                const setTake = (e) => {
                    take.value = e;
                   
                }

        function convertColumnName(name, columns) {
            for (const column of columns) {
                const pattern = new RegExp(`^${column}_`);
                if (pattern.test(name)) {
                    return name.replace(pattern, `${column}.`);
                }
            }
            return name;
        }
        
        function convertArrayElements(arr, columns) {
            return _.map(arr, element => {
                if (_.isArray(element)) {
                    return convertArrayElements(element, columns);
                } else if (_.isString(element)) {
                    return convertColumnName(element, columns);
                }
                return element;
            });
        }


     


      

    



        const dukListCustomStore = new CustomStore({
            key: 'id',
           
            load: async (loadOptions) => {
                const columns = ['simpeg_pegawais','cabangs', 'units', 'pegawai_statuses',  'sub_bagians', 'bagians', 'bidangs', 'sub_bidangs', 'seksis', 'golongans', 'jabatans', 'status_aktifs', 
                    'simpeg_kgbs', 'pphs'];
        

                let params = {};
                params.sort = "";params.filter="";
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;
                    }
                    params.sort = JSON.stringify(convertArrayElements(loadOptions.sort, columns));
                 
                
                }

                if(sort.value){
                    params.sort = JSON.stringify(convertArrayElements(sort, columns));
                }

               
                
                if (loadOptions.filter) {
                    loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format tanggal
                    let temp = [];
                    // if(route.query.filter && pegawaiListStore.state){
                    //     console.log("debug ROUTE.QUERY.FILTER");
                    //    temp = route.query.filter;
                    // }else{
             
                    //     temp = removeFilterCriteria( loadOptions.filter, 'pegawai_id');
                    // }
                    temp = convertArrayElements(loadOptions.filter, columns)
                    params.filter = JSON.stringify(temp);

                }

                if(filter.value){
                    loadOptions.filter = processLoadArray(filter.value); //benerin format tanggal
                    let temp = [];
                   
                    temp = convertArrayElements(loadOptions.filter, columns)
                    params.filter = JSON.stringify(temp);
                }else{
                    const currentDate = DateTime.now().set({ day: 1 }).toISODate();
                    params.filter = JSON.stringify(['tgl', '=', currentDate]);
                }


               // ================FILTER DEFAULT --> filter pegawai yang aktif
                loadOptions.filterDefault = [];
                // if(params.filter === ""){
                   
                   
                // }
            
                // if (additionalParams) {
                //     var coba = convertArrayElements(additionalParams, columns);
                    
                //     loadOptions.filterDefault.push(coba);
                // }
                
                params.filterDefault = JSON.stringify(loadOptions.filterDefault );

                //================SORT DEFAULT --> sort jabatan_id asc, nik
                loadOptions.sortDefault = [];
                // if(!params.sort.includes("jabatans.nama")){
                //     loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                // }
                // if(!params.sort.includes("nik")){
                //     loadOptions.sortDefault.push({"selector":"nik","desc":false});
                // }

                const hasOnlyTableId = loadOptions.sort && loadOptions.sort.length === 1 && _.get(loadOptions.sort[0], 'selector') === 'simpeg_pegawais_id';
            
               
                if(params.sort === "" || hasOnlyTableId){
                    // loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                    // loadOptions.sortDefault.push({"selector":"nik","desc":false});
                    // loadOptions.sortDefault.push({"selector":"pegawai_statuses.id","desc":false});
                    // loadOptions.sortDefault.push({"selector":"tgl_mulai_bekerja","desc":false});
                    // loadOptions.sortDefault.push({"selector":"nama","desc":false});
                    params.sort = "";
                }
                    
                params.sortDefault = JSON.stringify(loadOptions.sortDefault );

                ////////////////////////////////////

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                // if (loadOptions.take) {
                //     params.take = loadOptions.take;
                // }

                // if (loadOptions.take && take.value !== 'all') {
                //     params.take = loadOptions.take;
                // }
                params.take = take.value === 'all' ? null : loadOptions.take; // Fetch all if 'all' is set
                params.skip = loadOptions.skip || 0;


               

                const response = await axios.get(`${API_BASE_URL}/customstore-duks`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
                
                
          
              
                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }

                throw 'Data loading error';
            },
        });





          
       

        function processLoadArray(loadArray) {
            return _.map(loadArray, item => {
                if (_.isArray(item)) {
                    // Check if 'periode_absen' is present in the sub-array
                    if (_.includes(item, 'tgl_mulai_bekerja') || _.includes(item, 'tgl_lahir') || _.includes(item, 'pensiun_tgl')) {
                        // Map through the sub-array to find and convert Date objects
                        return _.map(item, subItem => {
                            return subItem instanceof Date ? formatDateToISOString(subItem) : subItem;
                        });
                    } else {
                        // Recursively process nested arrays
                        return processLoadArray(item);
                    }
                }
                return item;
            });
        }

        



        function formatDateToISOString(date) {
            function pad(n) { return n < 10 ? '0' + n : n }
            return date.getFullYear() + '-' +
                pad(date.getMonth() + 1) + '-' +
                pad(date.getDate());
        }


        return {
            dukListCustomStore,
            filter,
            sort,
            take,
            setFilter,
            setTake,
            setSort
        }
    });